import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./App.scss";
import { useAppAxios } from "./hooks/useAppAxios";
import { useInitiateApp } from "./hooks/useInitiateApp";
import CrmRouter from "./CrmRouter";

function App() {
  // Custom hook to set axios interceptors
  useAppAxios();

  const loadingData = useInitiateApp();

  return loadingData ? <div></div> : <CrmRouter />;
}

export default App;
